import React, { useEffect } from 'react';
import { shape, string } from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';

const ImpressionRunner = ({ targetRef, bundleId }) => {
  const { clickID } = useImpression({
    ref: targetRef,
    data: {
      component: 'BundleMini',
      id: bundleId,
      name: 'BundleMini',
      position: 1,
      type: 'product'
    }
  });

  useEffect(() => {
    const node = targetRef?.current;
    if (!node || !clickID) return undefined;
    node.setAttribute('clickid', clickID);
    return () => {
      if (node) node.removeAttribute('clickid');
    };
  }, [targetRef, clickID]);

  return null;
};

ImpressionRunner.propTypes = {
  targetRef: shape({
    current: shape({})
  }),
  bundleId: string.isRequired
};
ImpressionRunner.defaultProps = {
  targetRef: null
};

export { ImpressionRunner };